/*
 * @Author: Leeon 282276848@qq.com
 * @Date: 2024-01-15 10:04:39
 * @LastEditors: Leeon 282276848@qq.com
 * @LastEditTime: 2024-09-09 16:05:15
 * @FilePath: \tx-loan-h5\src\utils\bridge.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 客户端方法
// import { isWeixin } from '../../public/js/base'

function setupWebViewJavascriptBridge(callback) {

  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }

  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  // 检查是否在浏览器环境中
  if (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent) {
    // 检查是否在 iOS 设备上
    const isiOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    if (isiOS) {
      window.WVJBCallbacks = [callback];
      const WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";

      WVJBIframe.src = "https://__bridge_loaded__";
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    } else {
      // 在非 iOS 环境中，直接调用回调
      callback({});
    }
  } else {
    // 在非浏览器环境中，直接调用回调
    callback({});
  }
}

//初始化
setupWebViewJavascriptBridge(function (bridge) {
  try {
    bridge.init(function (message, callback) {
      callback(null);
    });
    // eslint-disable-next-line no-empty
  } catch (e) { }
});

export default {
  callhandler(name, data = {}, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler(name, data, callback);
    });
  },

  registerhandler(name, callback) {
    setupWebViewJavascriptBridge(function (bridge) {
      bridge.registerHandler(name, function (data, responseCallback) {
        callback(data, responseCallback);
      });
    });
  },
};
